import { Alert, AlertTitle, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useWizardData } from '../hooks/useWizardData';
import { WizardFormData } from '../schemas';

const CampaignLinkRender = () => {
  const { watch } = useFormContext<WizardFormData>();
  const { domains } = useWizardData();

  const entryDomainId = watch('campaignEntryDomainId');

  const campaignDomain = domains.find((domain) => domain._id === entryDomainId);

  if (!campaignDomain) {
    return null;
  }

  const campaignLink = `${campaignDomain.domainLink}/campaign/123-456-789-sample?x1=sample-x1&clkid=sample-clkid`;

  return (
    <Alert severity="info">
      <AlertTitle>Sample Campaign Link</AlertTitle>
      <Typography variant="body2">{campaignLink}</Typography>
    </Alert>
  );
};

export default CampaignLinkRender;
